import Papa from 'papaparse';

export const exportData = (data, fileName, columnOrder) => {
    let reorderedData = [];
    if (columnOrder?.length > 0) {
        reorderedData = data.map(item => {
            const reorderedItem = {};
            columnOrder.forEach(column => {
                reorderedItem[column] = item[column];
            });
            return reorderedItem;
        });
    }
    const csv = Papa.unparse(columnOrder?.length > 0 ? reorderedData : data);
    const csvData = new Blob([csv], { type: 'text/csv' });
    const csvUrl = URL.createObjectURL(csvData);

    const link = document.createElement('a');
    link.href = csvUrl;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}